<gl-base-modal (closeModal)="close(false)">
  <p class="info" [innerHTML]="'price_list_info_beta' | translate"></p>
</gl-base-modal>
